<template>
    <div class="page-wrap">
        <css-import-write-file
            :cssStr="cssStr"
            @file-upload="handleFileUpload"
        />
        <css-import-upload-file
            @file-upload="handleFileUpload"
        />
    </div>
</template>

<script>
import CssImportWriteFile from '@/components/admin/css-import/CssImportWriteFile.vue';
import CssImportUploadFile from '@/components/admin/css-import/CssImportUploadFile.vue';
import api from '@/api';
export default {
    components: {
        CssImportWriteFile,
        CssImportUploadFile,
    },
    data () {
        return {
            cssStr: "",
        };
    },
    mounted () {
        this.getCss();
    },
    methods: {
        async getCss () {
            try {
                const res = await api.getCss();
                this.cssStr = res.data;
            } catch (error) {
                console.warn(error);
            }
        },
        async handleFileUpload (file) {
            // API handles both file and string upload
            try {
                const formData = new FormData();
                formData.append('css', file);
                const res = await api.postCss(formData);
                this.EventBus.$emit('info', {
                    message: 'Css file uploaded!'
                });
            } catch (error) {
                console.warn(error);
            }
        },
        editorInit () {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/css')
            require('brace/mode/javascript') //language
            require('brace/mode/less')
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
    },
};
</script>

<style lang="scss" scoped>
.page-wrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 2em;
}
</style>